const Contact = () => {
    return (
        <main className="section">
        <div className="container">
                <h1 className="title-1">Contacts</h1>

                <ul className="content-list">
                    <li className="content-list__item">
                        <h2 claclassNamess="title-2">Location</h2>
                        <p>Kyiv, Ukraine</p>
                    </li>
                    <li clasclassNames="content-list__item">
                        <h2 className="title-2">Telegram / Viber</h2>
                        <p><a href="tel:+79051234567">+38 (067) 681-93-95</a></p>
                    </li>
                    <li className="content-list__item">
                        <h2 className="title-2">Email</h2>
                        <p><a className="mailto:webdev@protonmail.com">egorsitenko35@gmail.com</a></p>
                    </li>
                </ul>

        </div>
    </main>
    )
}

export default Contact;